module.exports = __webpack_public_path__ + "static/img/egc_logo_min.5b818f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/egc_logo_min.svg
// module id = Kd1s
// module chunks = 0